var map = {
	"./1 - Slow Shutter.jpeg": "a710",
	"./2 - Fast Shutter.jpeg": "1156",
	"./Aperature Priority-High.jpg": "c02f",
	"./Aperature Priority-Low.jpg": "6103",
	"./Aperature Priority-Med.jpg": "2811",
	"./Architechural.jpeg": "3f6a",
	"./Banner.jpg": "f117",
	"./BigWaterfall.gif": "7cfe",
	"./BigWaterfall.jpg": "6cf2",
	"./ColouredGel-Headshot.jpeg": "7374",
	"./ColouredGel-StillLife.jpeg": "318a",
	"./IMG_7702.jpg": "772e",
	"./IMG_7703.jpg": "38a0",
	"./IMG_7704.jpg": "d91d",
	"./JordanM-Part1.png": "9057",
	"./JordanM-Part2.png": "fe07",
	"./JordanMCinemagraphPic.jpg": "1487",
	"./NaturalLight-Headshot.jpeg": "da68",
	"./StudioLight-StillLife.jpeg": "9370",
	"./SurrealisticCinemaGraph.gif": "055d",
	"./WebsiteBackgroundcompressed.mp4": "a6f4",
	"./WindowKeyLight-StillLife.jpeg": "4d52",
	"./WoodenWolf.jpg": "732d",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./logo_old.png": "df01",
	"./logo_old.svg": "aea0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";